/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_State_DisqualifiedInputs */



/**
* | output |
* | --- |
* | "Disqualified" |
*
* @param {Player_State_DisqualifiedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const player_state_disqualified = /** @type {((inputs?: Player_State_DisqualifiedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_State_DisqualifiedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Disqualifié")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descalificado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Desqualificado")
	if (locale === "it") return /** @type {LocalizedString} */ ("Squalificato")
	return /** @type {LocalizedString} */ ("Disqualified")
});